import React from "react";
import { graphql } from "gatsby";
import { Layout } from "~/templates/Layout";
import { Hero } from "../molecules/IndexPageHero";
import { Services } from "~/molecules/IndexPageServices";
import { Features } from "~/molecules/IndexPageFeatures";
import { CasesOnTop } from "~/molecules/IndexPageCases";
import { CompanyLogos } from "~/molecules/CompanyLogos";
import { Process } from "~/molecules/IndexPageProcess";
import { AskUsCompact } from "~/molecules/IndexPageAskUsCompact";
import { Questions } from "~/molecules/IndexPageQuestions";

type Props = {
  data: {
    allContentfulCase: GatsbyTypes.ContentfulCaseConnection;
  };
};

const IndexPage: React.FC<Props> = ({ data }) => {
  const caseCards = data.allContentfulCase.edges
    .map((edge) => edge.node)
    .filter((node): node is GatsbyTypes.ContentfulCase => Boolean(node));

  return (
    <>
      <Layout isTopPage>
        <Hero />
        <CompanyLogos />
        {/* 制度〜定着のプロセス */}
        <Process />
        <Services />
        <Features />
        <AskUsCompact />
        <CasesOnTop caseCards={caseCards} />
        <Questions />
      </Layout>
    </>
  );
};

export default IndexPage;

export const IndexPageCaseQuery = graphql`
  query IndexPageCase {
    allContentfulCase(sort: { fields: date, order: DESC }, limit: 12) {
      edges {
        node {
          id
          contentful_id
          title
          company {
            id
            name
          }
          ogpImage {
            gatsbyImageData(aspectRatio: 1.618, width: 600)
          }
        }
      }
    }
  }
`;
